import React from "react";
import Sidebar from "../../../../component/Navigation/Sidebar/Sidebar";
import LoadingSpinner from "../../../../component/Loading/component";
import addtagicon from "../../../../assests/addtagpayicon.svg";
import addruleicon from "../../../../assests/addruleicon.svg";
import tagdepartmenticon from "../../../../assests/tagdepartmenticon.svg"
import tagpaytagicon from "../../../../assests/tagpaytagicon.svg";
import tagpayruleicon from "../../../../assests/tagpayruleicon.svg"
import tagpayusagelimiticon from "../../../../assests/tagpayusagelimiticon.svg"
import historyIcon from "../../../../assests/historyIcon.svg";
import "./TagPayDashboard.css";

const TagPayDashboardComponent = ({
    corporateId,
    corporateName,
    dashboardData,
    loading,
    error,
    onAddTag,
    onAddRule,
    onViewDepartments,
    onViewTags,
    onViewRules,
    onViewUsageLimit,
    onViewRechargeHistory,
    onBackClick,
    onRefresh,
    accountType
}) => {

    // Check account type
    const isWalletAccount = accountType === "WALLET" || accountType === "WALLET_RFID";

    // Format frequency display
    const formatFrequency = (frequency, duration) => {
        const freq = frequency?.toUpperCase() || "";
        
        if (freq === "HOURS" || freq === "HOUR") {
            return `${duration} Hour${duration > 1 ? 's' : ''}`;
        }
        if (freq === "DAYS" || freq === "DAY") {
            return `${duration} Day${duration > 1 ? 's' : ''}`;
        }
        if (freq === "MONTHS" || freq === "MONTH") {
            return `${duration} Month${duration > 1 ? 's' : ''}`;
        }
        return `${duration} period(s)`;
    };

    // Format usage limit display with proper UI
    const getUsageLimitDisplay = () => {
        if (!dashboardData?.tagUsageLimits || dashboardData.tagUsageLimits.length === 0) {
            return { hasLimits: false, amountLimit: null, transactionLimit: null };
        }
        
        const amountLimit = dashboardData.tagUsageLimits.find(limit => limit.limitOn === "AMOUNT");
        const transactionLimit = dashboardData.tagUsageLimits.find(limit => limit.limitOn === "TRANSACTION");
        
        return {
            hasLimits: true,
            amountLimit: amountLimit ? {
                value: amountLimit.value,
                frequency: amountLimit.frequency,
                duration: amountLimit.duration,
                displayText: `₹${amountLimit.value.toLocaleString('en-IN')} / ${formatFrequency(amountLimit.frequency, amountLimit.duration)}`
            } : null,
            transactionLimit: transactionLimit ? {
                value: transactionLimit.value,
                frequency: transactionLimit.frequency,
                duration: transactionLimit.duration,
                displayText: `${transactionLimit.value.toLocaleString('en-IN')}  / ${formatFrequency(transactionLimit.frequency, transactionLimit.duration)}`
            } : null
        };
    };

    const stats = {
        totalDepartments: dashboardData?.totalDepartments || 0,
        totalTags: dashboardData?.totalTags || 0,
        totalRules: dashboardData?.totalRules || 0,
        usageLimits: getUsageLimitDisplay(),
        name: dashboardData?.corporateName || corporateName || "User",
        accountType: accountType || dashboardData?.accountType || "WALLET_RFID"
    };

    if (error) {
        return (
            <div className="tp-dashboard-wrapper">
                <Sidebar />
                <div className="tp-dashboard-main">
                    <div className="tp-error-box">
                        <div className="tp-error-icon">⚠️</div>
                        <h3>Error Loading Dashboard</h3>
                        <p>{error}</p>
                        <button className="tp-retry-btn" onClick={onRefresh}>
                            Try Again
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            {loading ? (
                <LoadingSpinner />
            ) : (
                <div className="tp-dashboard-wrapper">
                    <Sidebar />

                    <div className="tp-dashboard-main">
                        {/* Header */}
                        <div className="tp-header">
                            <button onClick={onBackClick} className="tp-back-btn">
                                ←
                            </button>
                            <h1 className="tp-title">Tag Pay Management</h1>
                            <button 
                                className="tp-recharge-history-btn"
                                onClick={onViewRechargeHistory}
                            >
                                <img src={historyIcon} alt="history" />
                                <span>Recharge History</span>
                            </button>
                        </div>

                        {/* Welcome Section */}
                        <div className="tp-welcome">
                            <h2 className="tp-welcome-title">Welcome, {stats.name}</h2>
                            <p className="tp-welcome-desc">
                                Manage your departments, tags, and operational rules from a central overview. Access quick actions to maintain your workspace efficiently.
                            </p>
                        </div>

                        {/* Stats Row */}
                        <div className="tp-stats-row">
                            {/* Departments Card */}
                            <div className="tp-stat-item" onClick={onViewDepartments}>
                                <div className="tp-stat-info">
                                    <span className="tp-stat-label">Departments</span>
                                    <span className="tp-stat-number">{String(stats.totalDepartments).padStart(1, '0')}</span>
                                </div>
                                <div className="tp-stat-icon"> 
                                    <img src={tagdepartmenticon} alt="departments" /> 
                                </div>
                            </div>

                            {/* Tags Card */}
                            <div className="tp-stat-item" onClick={onViewTags}>
                                <div className="tp-stat-info">
                                    <span className="tp-stat-label">Tags</span>
                                    <span className="tp-stat-number">{String(stats.totalTags).padStart(1, '0')}</span>
                                </div>
                                <div className="tp-stat-icon">
                                    <img src={tagpaytagicon} alt="tags" />
                                </div>
                            </div>

                            {/* Rules Card */}
                            <div className="tp-stat-item" onClick={onViewRules}>
                                <div className="tp-stat-info">
                                    <span className="tp-stat-label">Rules</span>
                                    <span className="tp-stat-number">{String(stats.totalRules).padStart(1, '0')}</span>
                                </div>
                                <div className="tp-stat-icon">
                                    <img src={tagpayruleicon} alt="rules" />
                                </div>
                            </div>

                            {/* Usage Limit Card */}
                            <div className="tp-stat-item tp-usage-limit-card" onClick={onViewUsageLimit}>
                                <div className="tp-stat-info">
                                    <span className="tp-stat-label">Usage Limit</span>
                                    {stats.usageLimits.hasLimits ? (
                                        <div className="tp-usage-limits-container">
                                            {stats.usageLimits.amountLimit && (
                                                <div className="tp-usage-limit-row">
                                                    <span className="tp-usage-limit-icon1">Amount : </span>
                                                    <div className="tp-usage-limit-details">
                                                        <span className="tp-usage-limit-value">
                                                            {stats.usageLimits.amountLimit.displayText}
                                                        </span>
                                                    </div>
                                                </div>
                                            )}
                                            {stats.usageLimits.transactionLimit && (
                                                <div className="tp-usage-limit-row">
                                                    <span className="tp-usage-limit-icon1">Transaction : </span>
                                                    <div className="tp-usage-limit-details">
                                                        <span className="tp-usage-limit-value">
                                                            {stats.usageLimits.transactionLimit.displayText}
                                                        </span>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    ) : (
                                        <div className="tp-not-configured">
                                            <span className="tp-not-configured-text">Not Configured</span>
                                        </div>
                                    )}
                                </div>
                                <div className="tp-stat-icon">
                                    <img src={tagpayusagelimiticon} alt="usage limit" />
                                </div>
                            </div>
                        </div>

                        {/* Quick Actions */}
                        <div className="tp-actions">
                            <h3 className="tp-actions-title">Quick Actions</h3>
                            <div className="tp-actions-grid">
                                <button className="tp-action-btn tp-action-primary" onClick={onAddTag}>
                                    <div className="tp-action-icon">
                                        <img src={addtagicon} alt="add tag" />
                                    </div>
                                    Add Tag
                                </button>

                                <button className="tp-action-btn tp-action-primary" onClick={onAddRule}>
                                    <span className="tp-action-icon">
                                        <img src={addruleicon} alt="add rule" />
                                    </span>
                                    Add Rule
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default TagPayDashboardComponent;